import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import './Dashboard.css';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faEdit, faTrashAlt, faPlus } from '@fortawesome/free-solid-svg-icons';
import { baseUrl } from '../components/constant';
import { toast } from 'react-toastify';

const Notifications = () => {
  const [categories, setCategories] = useState([]);
  
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');
  const [showModal, setShowModal] = useState(false);
  const [categoryToDelete, setCategoryToDelete] = useState(null);
  const [currentPage, setCurrentPage] = useState(1);
  const [lastPage, setLastPage] = useState(1);
  const navigate = useNavigate();
 
  const fetchNotifcation = async () => {
    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      console.log("token",token)
      const response = await fetch(`${baseUrl}/notifications`, {
        method: 'GET',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
        },
      });

      if (response.ok) {
        const data = await response.json();
        setCategories(data.notifications); // Adjust based on your API response structure
      } else {
        toast.error('Failed to fetch brand');
      }
    } catch (err) {
      setError('Failed to fetch brand');
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchNotifcation();
  }, []);



  const handleDeleteClick = (category) => {
    setCategoryToDelete(category);
    setShowModal(true);
  };

  const confirmDelete = async () => {
    if (!categoryToDelete) return;

    setLoading(true);
    try {
      const token = JSON.parse(localStorage.getItem('token'));
      const response = await fetch(`${baseUrl}/coupons/${categoryToDelete.id}`, {
        method: 'DELETE',
        headers: {
          'Accept': 'application/json',
          'Authorization': `Bearer ${token}`,
          'x-api-key': 'web-app',
        },
      });

      if (response.ok) {
        toast.success('Coupon deleted successfully!');
        // Remove the deleted category from the state
        setCategories(categories.filter(category => category.id !== categoryToDelete.id));
        setShowModal(false); // Close the modal after successful deletion
      } else {
        toast.error('Failed to delete Coupon');
      }
    } catch (err) {
      toast.error('An error occurred while deleting the Coupon.');
    } finally {
      setLoading(false);
    }
  };

  const cancelDelete = () => {
    setShowModal(false);
    setCategoryToDelete(null);
  };

  const handleAddNewCategory = () => {
    navigate('/Notifications/new-Notifcation');
  };

  const handlePreviousPage = () => {
    if (currentPage > 1) {
      setCurrentPage(currentPage - 1);
    }
  }; 

  const handleNextPage = () => {
    if (currentPage < lastPage) {
      setCurrentPage(currentPage + 1);
    }
  };

 
  return (
    <div className="dashboard">
      <button className="add-category-button" onClick={handleAddNewCategory} style={{ backgroundColor: 'rgb(154, 57, 57)' }}>
        <FontAwesomeIcon icon={faPlus} /> Send New Notification
      </button>
      <div className="category-list">
        {loading && (
          <div className="loader-overlay">
            <div className="loader"></div>
          </div>
        )}
        {!loading && categories.map(Coupon => (
          <div key={Coupon.id} className="category-item">
            <div className="">
              <span className="category-id">ID: {Coupon.id}</span>
              <h3 className="category-name" style={{ color: "rgb(154, 57, 57)" }}>Title : {Coupon.title.en}</h3>
              <h3 className="category-name" style={{ color: "rgb(154, 57, 57)" }}>Body : {Coupon.body.ar}</h3>
              
              <div className="buttons">
              
              
              </div>
            </div>
          </div>
        ))}
      </div>

 {lastPage > 1 && 
 
      <div className="pagination-controls">
        <button
          onClick={handlePreviousPage}
          disabled={currentPage === 1}
          style={{ marginRight: '10px', backgroundColor: 'rgb(154, 57, 57)', color: '#fff' }}
        >
          Previous
        </button>
        <span>Page {currentPage} of {lastPage}</span>
        <button
          onClick={handleNextPage}
          disabled={currentPage === lastPage}
          style={{ marginLeft: '10px', backgroundColor: 'rgb(154, 57, 57)', color: '#fff' }}
        >
          Next
        </button>
      </div>
 }

      {showModal && (
        <div className="modal show">
          <div className="modal-content">
            <h3 style={{ color: '#000' }}>Are you sure you want to delete this Coupon?</h3>
            <button className="cancel-button" onClick={cancelDelete} style={{ backgroundColor: "#000" }}>Cancel</button>
            <button className="delete-button" onClick={confirmDelete} style={{ backgroundColor: 'rgb(154, 57, 57)' }}>Delete</button>
          </div>
        </div>
      )}
    </div>
  );
};

export default Notifications;
